import React from "react";

const features = [
  {
    emoji: "⚡",
    title: "Instant Entry",
    desc: "Participants join the Reunion Hall using a simple Entry Pass shared by the Organizer.",
  },
  {
    emoji: "🎮",
    title: "Live Quiz Experience",
    desc: "Play exciting real-time quizzes during celebrations, meetings and community events.",
  },
  {
    emoji: "📊",
    title: "Live Analytics",
    desc: "Watch participation, answers, trends and engagement update live throughout the event.",
  },
  {
    emoji: "🏆",
    title: "Winner Celebration",
    desc: "Reveal Semi Finalists and Winners with a beautiful live announcement experience.",
  },
  {
    emoji: "🎁",
    title: "Sponsor Branding",
    desc: "Highlight sponsors, donors and special messages throughout the event.",
  },
  {
    emoji: "📱",
    title: "Mobile First",
    desc: "Designed for every smartphone user with a simple, fast and responsive experience.",
  },
  {
    emoji: "🌍",
    title: "Community Ready",
    desc: "Perfect for schools, colleges, housing societies, offices, festivals and family gatherings.",
  },
  {
    emoji: "💜",
    title: "Think5Whys Ecosystem",
    desc: "Powered by Think5Whys and PurpleDoor for secure, scalable and engaging experiences.",
  },
];

const ReunionFeatures = () => {
  return (
    <section className="relative py-20 px-6 bg-gradient-to-b from-[#071b18] via-[#081311] to-[#050505]">

      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-4">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-emerald-500/10 border border-emerald-400/20 mb-5">
            <span className="text-xl">✨</span>
            <span className="uppercase tracking-[0.3em] text-xs font-semibold text-emerald-300">
              Why Reunion?
            </span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-black text-white mb-5">
            One Platform.
            <br />
            Endless Celebrations.
          </h2>

          <p className="max-w-3xl mx-auto text-emerald-100/80 text-sm lg:text-lg leading-relaxed">
            Reunion transforms ordinary gatherings into engaging live experiences
            where everyone participates, enjoys, competes and celebrates
            together.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">

          {features.map((item, index) => (
            <div
              key={index}
              className="group rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md p-6 hover:border-emerald-400/40 hover:bg-emerald-500/10 transition-all duration-300 hover:-translate-y-2"
            >
              <div className="text-5xl mb-5 group-hover:scale-110 transition-transform">
                {item.emoji}
              </div>

              <h3 className="text-lg font-bold text-white mb-3">
                {item.title}
              </h3>

              <p className="text-sm text-emerald-100/80 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}

        </div>

        {/* Bottom Highlight */}
        <div className="mt-16 rounded-3xl border border-emerald-500/20 bg-gradient-to-r from-emerald-500/10 via-teal-500/10 to-purple-500/10 p-8 text-center">

          <div className="text-5xl mb-4">🫂</div>

          <h3 className="text-2xl lg:text-3xl font-black text-white mb-4">
            Bring Every Community Together
          </h3>

          <p className="max-w-4xl mx-auto text-emerald-100/80 text-sm lg:text-lg leading-relaxed">
            Whether it's a birthday celebration, school reunion, housing society
            event, corporate gathering, religious function or college festival,
            Reunion makes participation fun, interactive and memorable for
            everyone.
          </p>

        </div>

      </div>

    </section>
  );
};

export default ReunionFeatures;